import {
  React,
  useState,
  useEffect,
  LoaderOverlay,
  withAuth,
  toast,
  connect,
  useDispatch,
  useSelector,
  useNavigate,
  MESSAGES,
} from "./../../common/helper/common-imports.component.js";
import {
  RowsPerPageSelector,
  SearchTable,
  DataTable,
  customDataTableStyles,
} from "./../../common/helper/table-imports.js";
import BankingPartnersService from "../../../services/banking-partners-service.js";
import Confirmation from "../../common/modals/confirmation.component.js";
import { bankingPartnersColumns } from "./banking-partners-col.component.js";

const BankingPartners = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [partners, setPartners] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [modalData, setModalData] = useState({});

  const paginationComponentOptions = {
    noRowsPerPage: true,
  };

  const handleEdit = (row) => {
    navigate(`/edit-banking-partner/${row.id}`);
  };

  const handleToggleStatus = (row) => {
    setModalShow(true);
    setModalData({
      id: row.id,
      partner_name: row.partner_name,
      is_active: row.is_active,
      modalId: "statusChangeBankingPartner",
    });
  };

  const handleDelete = (row) => {
    setModalShow(true);
    setModalData({
      id: row.id,
      partner_name: row.partner_name,
      modalId: "deleteBankingPartner",
    });
  };

  const confirmAction = () => {
    if (modalData.modalId === "statusChangeBankingPartner") {
      const newStatus = !modalData.is_active;
      const action = newStatus ? "activate" : "deactivate";

      setLoading(true);
      BankingPartnersService.updateStatus(modalData.id, newStatus)
        .then(() => {
          toast.success(`Partner ${action}d successfully.`);
          fetchBankingPartners();
          setModalShow(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error?.response?.data?.error?.message || MESSAGES.SERVER_ERROR);
        });
    } else if (modalData.modalId === "deleteBankingPartner") {
      setLoading(true);
      BankingPartnersService.deletePartner(modalData.id)
        .then(() => {
          toast.success("Partner deleted successfully.");
          fetchBankingPartners();
          setModalShow(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error?.response?.data?.error?.message || MESSAGES.SERVER_ERROR);
        });
    }
  };

  const [columns] = useState(bankingPartnersColumns(handleEdit, handleToggleStatus, handleDelete));

  const fetchBankingPartners = () => {
    setLoading(true);
    BankingPartnersService.getBankingPartners()
      .then((response) => {
        console.log(response.data.data)
        setPartners(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error?.message || MESSAGES.SERVER_ERROR);
      });
  };

  useEffect(() => {
    fetchBankingPartners();

    document.body.style.backgroundImage = "";
    document.body.style.backgroundColor = "#f0f6fa";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  useEffect(() => {
    if (partners?.length) {
      const element = document.getElementsByClassName("sc-bHCmUC");
      if (element[0]) {
        const childElement = element[0].children;
        for (let i = 0; i < childElement?.length; i++) {
          const ele = childElement[i].id.split("-")[1];
          if (Number(ele) % 2 === 0) {
            childElement[i].classList.add("even-transaction-table");
          } else {
            childElement[i].classList.add("odd-transaction-table");
          }
        }
      }
    }
  }, [partners]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey((prev) => prev + 1);
  };

  const filteredData = partners.filter((row) =>
    Object.values(row).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <div className="d-flex justify-content-between mb-3">
          <h4
            className="mb-0 updatename updatename1 align-self-center text-color-theme"
            style={{ marginTop: 0, fontWeight: 700, fontSize: "22px" }}
          >
            Banking Partners
          </h4>
      
        </div>

        <div className="container" style={{ backgroundColor: "white" }}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className="nav-link tbbtn active"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
              >
                Partners List
              </button>
            </div>
          </nav>

          <div className="filterBtn">
            <div id="examplemgm_filter" className="dataTables_filter">
              <label>
                <SearchTable
                  searchTerm={searchTerm}
                  handleSearchChange={handleSearchChange}
                />
              </label>
            </div>
          </div>

          <RowsPerPageSelector
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
          />

          <div
            className="tab-content"
            id="nav-tabContent"
            style={{ paddingTop: "15px", paddingBottom: "15px" }}
          >
            <div
              className="tab-pane fade active show"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div
                id="examplemgmwallet_wrapper"
                className="dataTables_wrapper dt-jqueryui no-footer"
              >
                <DataTable
                  key={dataTableKey}
                  columns={columns}
                  data={filteredData}
                  pagination
                  paginationComponentOptions={paginationComponentOptions}
                  paginationPerPage={rowsPerPage}
                  customStyles={customDataTableStyles}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={() => confirmAction()}
        status={modalData.is_active ? 'Active' : 'Inactive'}
        modalId={modalData.modalId}
        partner_name={modalData.partner_name}
      />
    </>
  );
};

function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(BankingPartners));
